import React from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Stack,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import TipsAndUpdatesOutlinedIcon from '@mui/icons-material/TipsAndUpdatesOutlined';

const TIPS = [
  { label: 'Wörter anklicken', text: 'springt zur Stelle im Audio.' },
  {
    label: 'Segment bearbeiten',
    text: 'geht über das Stift-Symbol; beim Verlassen des Textfelds wird automatisch gespeichert.',
  },
  {
    label: 'Zeit anklicken',
    text: 'springt zum Start des Segments, auch wenn der Text bereits bearbeitet wurde.',
  },
  {
    label: 'Sprecher benennen',
    text: 'öffnet den Assistenten mit Audio-Ausschnitten pro Sprecher – gleiche Namen werden automatisch zusammengeführt.',
  },
];

export default function TranscriptionTipsCard() {
  return (
    <Accordion
      disableGutters
      elevation={0}
      sx={{
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 2,
        overflow: 'hidden',
        '&:before': { display: 'none' },
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        sx={{ minHeight: 44, '& .MuiAccordionSummary-content': { my: 1 } }}
      >
        <Stack direction="row" spacing={1} alignItems="center">
          <TipsAndUpdatesOutlinedIcon
            fontSize="small"
            color="action"
          />
          <Typography variant="body2" fontWeight={500}>
            Tipps zur Bearbeitung
          </Typography>
        </Stack>
      </AccordionSummary>
      <AccordionDetails sx={{ pt: 0 }}>
        <Stack spacing={0.5}>
          {TIPS.map((t) => (
            <Typography
              key={t.label}
              variant="body2"
              color="text.secondary"
            >
              <strong>{t.label}:</strong> {t.text}
            </Typography>
          ))}
        </Stack>
      </AccordionDetails>
    </Accordion>
  );
}
